import { combineReducers } from 'redux';
import onboarding from './onboarding';
import permissions from './permissions';
import prescription from './prescription';
import user from './user';
import banner from './banner'
import { Action, ActionTypes } from './user/types';

const rootReducer = combineReducers({
  permissions,
  prescription,
  user,
  onboarding,
  banner
});

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const reducer = (state: any, action: Action) => {
  return rootReducer(action.type === ActionTypes.REMOVE_USER ? undefined : state, action);
};

export default reducer;
export type AppState = ReturnType<typeof rootReducer>;
